// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BatteryStatus_wrapper__u_Ae6"};